import React from 'react'
import { useSelector } from 'react-redux'
import AddressList from '../../domain/address/AddressList'
import TextError from '../../domain/genericComponents/TextError'
import { selectAddressError } from '../../store/address/address.selectors'

const AddressSearchDialogContent = () => {
  const addressError = useSelector(selectAddressError)

  if (addressError) {
    return <TextError error={addressError} />
  }

  return <AddressList />
}

export default AddressSearchDialogContent
